import { Button, makeStyles, shorthands } from '@fluentui/react-components';
import { Stop24Filled } from '@fluentui/react-icons';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface StopCompletionButtonProps {
    completionInProgress: boolean;
    onStopCompletion: () => void;
}

const useStyle = makeStyles({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        /* Remove extra spacing so this component doesn't create a visible gap */
        minHeight: '32px',
        marginBottom: '10px',
        ...shorthands.padding('0'),
        // Ensure no extra spacing on mobile either
        '@media (max-width: 768px)': {
            ...shorthands.padding('0'),
            minHeight: '32px',
        },
    },
});

const StopCompletionButton: FC<StopCompletionButtonProps> = (props) => {
    const { completionInProgress, onStopCompletion } = props;
    const classes = useStyle();
    const { t } = useTranslation();

    if (!completionInProgress) return null;

    return (
        <div className={classes.root}>
            <Button onClick={onStopCompletion} appearance='primary' icon={<Stop24Filled />}>
                {t('query.stopCompletion')}
            </Button>
        </div>
    );
};

export default StopCompletionButton;
